import Button from '../../components/button/Button'
import './timetable.scss'
import { useEffect, useMemo, useRef, useState } from 'react'
import dayjs from 'dayjs'
import Box from '@mui/material/Box'
import { Drawer, Typography } from '@mui/material'
import TimetableCard from '../../components/timetable-card/TimetableCard'
import closeIcon from '../../assets/icons/close.svg'
import PageDropdown from '../../components/page-dropdown/PageDropdown.jsx'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import Calendar from '../../components/calendar/Calendar.jsx'
import TimeRange from '../../components/time-range/TimeRange.jsx'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb.jsx'
import { permissions, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants.js'
import WeeklyCalendar from '../../components/weekly-calendar/WeeklyCalendar.jsx'
import { convertDateFormatCalendar, handleInput, generateDropdownOptions } from '../../utility/genricFunction.js'
import NewInput from '../../components/input/NewInput.jsx'
import WeeklyDateRange from '../../components/weekly-date-range/WeeklyDateRange.jsx'
import { useDispatch, useSelector } from 'react-redux'
import { createTimetable, deleteTimetable, editTimetable, getTimetable } from '../../store/builders/timetable/timetable.builder.js'
import { getBatch, getBranch, getClassRoom, getFaculties } from '../../store/builders/branch/branch.builder.js'
import { getCourse } from '../../store/builders/course/course.builder.js'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages.js'
import UseAuthorization from '../../utility/useAuthorization.js'
import MultiSelectDropdown from '../../components/multi-select-dropdown/MultiSelectDropdown.jsx'
import Loader from '../../components/loader/Loader.jsx'

function Timetable() {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth) || {}

  const branches = useSelector((state) => state?.branch?.branchTableData)
  // const batches = useSelector((state) => state.branch.batchData.result.batches)
  const classrooms = useSelector((state) => state?.branch?.classroomData?.result?.classroom)
  const faculties = useSelector((state) => state?.branch?.facultiesData?.result?.faculties)
  const courses = useSelector((state) => state.course.course)
  const timetable = useSelector((state) => state?.timetable)
  const loading = timetable?.loading
  const branch = useSelector((state) => state?.branch)
  const batches = branch?.batchData?.result?.batches

  const branchOption = useMemo(() => generateDropdownOptions(branches, 'branchName', 'branchId'), [branches])
  const facultyOption = useMemo(() => generateDropdownOptions(faculties, 'userName', 'facultyId'), [faculties])
  const roleName = user?.result?.userData?.roleName
  const facultyId = user?.result?.facultyId

  const [weekDates, setWeekDates] = useState([])
  const [weekDateValue, setWeekDateValue] = useState(dayjs())
  const [animationClass] = useState('')
  const [timetableData, setTimetableData] = useState([])
  const [saveState, setSaveState] = useState(false)
  const [open, setOpen] = useState(false)
  const batchOption = useRef([])
  const courseOption = useRef([])
  const moduleOption = useRef([])
  const topicOption = useRef([])
  const classroomOption = useRef([])
  const [formData, setFormData] = useState({
    title: '',
    dateSelectionType: '',
    dateSelectionSolo: false,
    dateSelectionWeek: false,
    date: '',
    startTime: '',
    endTime: '',
    branch: '',
    batch: '',
    classroom: '',
    faculty: '',
    course: '',
    module: '',
    topic: [],
    mcq: '',
    descriptive: '0',
    type: '',
    lecture: true,
    onlineExam: false,
    offlineExam: false,
    timeTableDrawerHeader: '',
    filter: false,
    add: false,
    edit: '',
    filteredDataArray: [],
    filterDataRender: false,
    weekly: false,
    startDate: '',
    endDate: '',
    timetableId: '',
  })
  const [newFilterData, setNewFilterData] = useState({
    title: '',
    dateSelectionType: '',
    dateSelectionSolo: false,
    dateSelectionWeek: false,
    date: '',
    startTime: '',
    endTime: '',
    branch: '',
    batch: '',
    classroom: '',
    faculty: '',
    course: '',
    module: '',
    topic: [],
    mcq: '',
    descriptive: '0',
    type: '',
    lecture: true,
    onlineExam: false,
    offlineExam: false,
    timeTableDrawerHeader: '',
    filter: false,
    add: false,
    edit: '',
    filteredDataArray: [],
    filterDataRender: false,
    weekly: false,
    startDate: '',
    endDate: '',
    timetableId: '',
  })
  useEffect(() => {
    dispatch(getBranch('active'))
    dispatch(getBatch('active'))
    dispatch(getClassRoom())
    dispatch(getFaculties('active'))
    dispatch(getCourse())
    facultyId
      ? getTimetable({ startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) })
      : getTimetable({ startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]), facultyId })
  }, [dispatch])

  useEffect(() => {
    setWeekDates(getCurrentWeekDates(weekDateValue))
  }, [weekDateValue])

  useEffect(() => {
    let data
    if (weekDates?.length) {
      const filterObj = {
        branchId: newFilterData.branch,
        branchClassroomId: newFilterData.classroom,
        type: newFilterData.type,
        batchId: newFilterData.batch,
        facultyId: newFilterData.faculty,
        startDate: newFilterData.startDate,
        endDate: newFilterData.endDate,
        courseModuleId: newFilterData.module,
        courseId: newFilterData.course,
        courseModuleTopicId: newFilterData.topic,
      }
      if (newFilterData.startDate) {
        data = facultyId ? { ...filterObj, facultyId } : { ...filterObj }
      } else {
        data = facultyId
          ? {
              ...filterObj,
              startDate: convertDateInTZ(weekDates[0]),
              endDate: convertDateInTZ(weekDates[6]),
              facultyId,
            }
          : { ...filterObj, startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) }
      }
      dispatch(getTimetable(data))
    }
  }, [dispatch, weekDates, saveState])

  useEffect(() => {
    setTimetableData(timetable.timetableData.map((innerArray) => innerArray.map((item) => item.timetableData)))
  }, [timetable])

  function convertDateInTZ(dateStr) {
    if (dateStr) {
      const [day, month, year] = dateStr.split('/')
      let date = new Date(year, month - 1, day)
      const yearStr = date.getFullYear()
      const monthStr = String(date.getMonth() + 1).padStart(2, '0')
      const dayStr = String(date.getDate()).padStart(2, '0')

      const formattedDate = `${yearStr}-${monthStr}-${dayStr}T00:00:00.000Z`
      return formattedDate
    }
  }

  const validationSchema = formData.filter
    ? Yup.object().shape({})
    : formData.onlineExam
      ? Yup.object().shape({
          endDate: Yup.string().optional().required(VALIDATION_MESSAGES.DATE),
          startTime: Yup.string().optional().required(VALIDATION_MESSAGES.START_DATE),
          endTime: Yup.string().optional().required(VALIDATION_MESSAGES.END_DATE),
          branch: Yup.string().optional().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
          batch: Yup.string().optional().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
          classroom: Yup.string().optional().required(VALIDATION_MESSAGES.CLASS_ROOM_REQUIRED),
          faculty: Yup.string().optional().required(VALIDATION_MESSAGES.FACULTY_REQUIRED),
          course: Yup.string().optional().required(VALIDATION_MESSAGES.COURSE_REQUIRED),
          module: Yup.string().optional().required(VALIDATION_MESSAGES.MODULE_NAME_REQUIRED),
          topic: Yup.array().of(Yup.string().required()).min(1, VALIDATION_MESSAGES.TOPIC_NAME_REQUIRED),
          mcq: Yup.string().optional().required(VALIDATION_MESSAGES.MCQ_REQUIRED),
          descriptive: Yup.string().optional().required(VALIDATION_MESSAGES.DESCRIPTIVE_REQUIRED),
        })
      : Yup.object().shape({
          endDate: Yup.string().optional().required(VALIDATION_MESSAGES.DATE),
          startTime: Yup.string().optional().required(VALIDATION_MESSAGES.START_DATE),
          endTime: Yup.string().optional().required(VALIDATION_MESSAGES.END_DATE),
          branch: Yup.string().optional().required(VALIDATION_MESSAGES.BRANCH_REQUIRED),
          batch: Yup.string().optional().required(VALIDATION_MESSAGES.BATCH_REQUIRED),
          classroom: Yup.string().optional().required(VALIDATION_MESSAGES.CLASS_ROOM_REQUIRED),
          faculty: Yup.string().optional().required(VALIDATION_MESSAGES.FACULTY_REQUIRED),
          course: Yup.string().optional().required(VALIDATION_MESSAGES.COURSE_REQUIRED),
          module: Yup.string().optional().required(VALIDATION_MESSAGES.MODULE_NAME_REQUIRED),
          topic: Yup.array().of(Yup.string().required()).min(1, VALIDATION_MESSAGES.TOPIC_NAME_REQUIRED),
        })

  const handleFormSubmit = (values) => {
    const addObj = {
      branchId: values.branch,
      branchClassroomId: values.classroom,
      type: values.title,
      batchId: values.batch,
      facultyId: values.faculty,
      startTime: formatTimeObjToAMPM(values.startTime),
      endTime: formatTimeObjToAMPM(values.endTime),
      startDate: values.startDate,
      endDate: values.endDate,
      courseModuleId: values.module,
      courseId: values.course,
      courseModuleTopicId: values.topic,
      // markDescriptive: values.descriptive,
      markDescriptive: '0',
      markMcq: values.mcq ? values.mcq : '0',
      totalMark: (Number(values.mcq) + Number(values.descriptive)).toString(),
    }
    const editObj = {
      branchId: values.branch,
      branchClassroomId: values.classroom,
      type: values.title,
      batchId: values.batch,
      facultyId: values.faculty,
      startTime: formatTimeObjToAMPM(values.startTime),
      endTime: formatTimeObjToAMPM(values.endTime),
      date: values.startDate,
      courseModuleId: values.module,
      courseId: values.course,
      courseModuleTopicId: values.topic,
      // markDescriptive: values.descriptive,
      markDescriptive: '0',
      markMcq: values.mcq ? values.mcq : '0',
      totalMark: (Number(values.mcq) + Number(values.descriptive)).toString(),
    }
    const filtersObj = {
      branchId: newFilterData.branch,
      branchClassroomId: newFilterData.classroom,
      type: newFilterData.type,
      batchId: newFilterData.batch,
      facultyId: newFilterData.faculty,
      startDate: newFilterData.startDate,
      endDate: newFilterData.endDate,
      courseModuleId: newFilterData.module,
      courseId: newFilterData.course,
      courseModuleTopicId: newFilterData.topic,
      markDescriptive: newFilterData.descriptive,
      markMcq: newFilterData.mcq,
    }
    if (formData.add) {
      const data = {
        saveState,
        setSaveState,
        data: addObj,
        setOpen,
        filter: { ...filtersObj, startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) },
      }
      dispatch(createTimetable(data))
    } else if (formData.edit) {
          setFormData((prevState) => ({
            ...prevState,
            branch: values.branch,
            classroom: values.classroom,
            type: values.title,
            batch: values.batch,
            faculty: values.faculty,
            startTime: values.startTime,
            endTime: values.endTime,
            date: values.startDate,
            module: values.module,
            course: values.course,
            topic: values.topic,
            mcq: values.mcq ? values.mcq : '0',
          }))
      if (!values.mcq && !values.descriptive) {
        delete editObj.markDescriptive
        delete editObj.markMcq
      }
      const data = {
        saveState,
        setSaveState,
        data: editObj,
        timetableId: formData.timetableId,
        setOpen,
        filter: { ...filtersObj, startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) },
      }
      dispatch(editTimetable(data))
    } else if (formData.filter) {
      const filterObj = facultyId
        ? {
            branchId: values.branch,
            branchClassroomId: values.classroom,
            type: values.type,
            batchId: values.batch,
            facultyId,
            startDate: values.startDate,
            endDate: values.endDate,
            courseModuleId: values.module,
            courseId: values.course,
            courseModuleTopicId: values.topic,
            // markDescriptive: values.descriptive,
            markDescriptive: '0',
            setOpen,
            markMcq: values.mcq,
            filter: true
          }
        : {
            branchId: values.branch,
            branchClassroomId: values.classroom,
            type: values.type,
            batchId: values.batch,
            facultyId: values.faculty,
            startDate: values.startDate,
            endDate: values.endDate,
            courseModuleId: values.module,
            courseId: values.course,
            courseModuleTopicId: values.topic,
            // markDescriptive: values.descriptive,
            markDescriptive: '0',
            markMcq: values.mcq,
            setOpen,
            filter: true
          }
      setNewFilterData((prevState) => {
        return {
          ...prevState,
          type: values.type,
          date: values.date,
          startDate: values.startDate,
          endDate: values.endDate,
          branch: values.branch,
          batch: values.batch,
          classroom: values.classroom,
          faculty: values.faculty,
          course: values.course,
          module: values.module,
          topic: values.topic,
          mcq: values.mcq,
          // descriptive: values.descriptive,
          descriptive: '0',
          filterDataRender: true,
        }
      })
      dispatch(getTimetable(filterObj))
    }
  }

  const getCurrentWeekDates = (currentDate) => {
    const dayOfWeek = currentDate.day()
    const startOfWeek = currentDate.subtract(dayOfWeek === 0 ? 6 : dayOfWeek - 1, 'day')
    const weekDates = []
    for (let i = 0; i < 7; i++) {
      const newDate = startOfWeek.clone().add(i, 'day').format('DD/MM/YYYY')
      weekDates.push(newDate)
    }
    return weekDates
  }

  function convertAMPMToObject(timeString) {
    const currentDate = new Date()
    const [time, period] = timeString.split(' ')
    const [hours, minutes] = time.split(':').map(Number)

    let adjustedHours = hours
    if (period === 'PM' && hours < 12) {
      adjustedHours += 12
    } else if (period === 'AM' && hours === 12) {
      adjustedHours = 0
    }

    const newDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      adjustedHours,
      minutes,
      0,
      0,
    )

    return newDate
  }

  const typeOption = [
    { label: 'Lecture', value: 'lecture' },
    { label: 'Online Exam', value: 'online_exam' },
    { label: 'Offline Exam', value: 'offline_exam' },
  ]

  function formatTimeObjToAMPM(dateStr) {
    let date = new Date(dateStr)
    let hours = date.getHours()
    let minutes = date.getMinutes()
    minutes = minutes < 10 ? '0' + minutes : minutes
    let period = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours ? hours : 12
    let formattedHours = hours < 10 ? '0' + hours : hours
    return `${formattedHours}:${minutes} ${period}`
  }

  function convertTZToDate(isoDateString) {
    const date = dayjs(isoDateString, 'YYYY-MM-DDTHH:mm:ss.SSSZ')

    // Format the date in the desired format: MM/DD/YYYY
    const formattedDate = date.format('YYYY-MM-DD')
    return formattedDate
  }

  const handleRadioChange = (value, resetForm) => {
    setFormData({
      ...formData,
      title: value,
      lecture: value === 'lecture',
      onlineExam: value === 'online_exam',
      offlineExam: value === 'offline_exam',
    })
    resetForm && resetForm()
  }

  const handleDateRadioChange = (value, setFieldValue) => {
    // Update the Formik field value
    setFieldValue('startDate', '')
    setFieldValue('endDate', '')
    setFieldValue('dateSelectionType', value)
    setFieldValue('dateSelectionSolo', value === 'dateSelectionSolo')
    setFieldValue('dateSelectionWeek', value === 'dateSelectionWeek')
  }

  const closeDrawer = () => {
    setOpen(false)
  }

  const handleFilter = () => {
    setFormData((prevState) => ({
      ...prevState,
      filter: true,
      add: false,
      edit: false,
      onlineExam: false,
      timeTableDrawerHeader: 'Apply Filters',
    }))
    facultyId
      ? setNewFilterData((prevState) => ({
          ...prevState,
          timeTableDrawerHeader: 'Apply Filters',
          onlineExam: false,
          title: '',
          type: '',
          startDate: '',
          endDate: '',
          startTime: '',
          endTime: '',
          branch: '',
          batch: '',
          classroom: '',
          faculty: facultyId,
          course: '',
          module: '',
          topic: [],
          mcq: '',
          descriptive: '',
          filter: true,
          add: false,
          edit: false,
          filteredDataArray: [],
          ...(newFilterData.filterDataRender && {
            title: prevState.title,
            type: prevState.type,
            startDate: prevState.startDate,
            endDate: prevState.endDate,
            startTime: prevState.startTime,
            endTime: prevState.endTime,
            branch: prevState.branch,
            batch: prevState.batch,
            classroom: prevState.classroom,
            faculty: facultyId,
            course: prevState.course,
            module: prevState.module,
            topic: prevState.topic,
            mcq: prevState.mcq,
            descriptive: prevState.descriptive,
          }),
        }))
      : setNewFilterData((prevState) => ({
          ...prevState,
          timeTableDrawerHeader: 'Apply Filters',
          onlineExam: false,
          title: '',
          type: '',
          startDate: '',
          endDate: '',
          startTime: '',
          endTime: '',
          branch: '',
          batch: '',
          classroom: '',
          faculty: '',
          course: '',
          module: '',
          topic: [],
          mcq: '',
          descriptive: '0',
          filter: true,
          add: false,
          edit: false,
          filteredDataArray: [],
          ...(newFilterData.filterDataRender && {
            title: prevState.title,
            type: prevState.type,
            startDate: prevState.startDate,
            endDate: prevState.endDate,
            startTime: prevState.startTime,
            endTime: prevState.endTime,
            branch: prevState.branch,
            batch: prevState.batch,
            classroom: prevState.classroom,
            faculty: prevState.faculty,
            course: prevState.course,
            module: prevState.module,
            topic: prevState.topic,
            mcq: prevState.mcq,
            descriptive: '0',
            // descriptive: prevState.descriptive,
          }),
        }))
    setOpen(true)
  }

  const handleClear = (e, resetForm) => {
    e.preventDefault()
    resetForm()
    setOpen(false)

    facultyId
      ? setNewFilterData((prevState) => ({
          ...prevState,
          filterDataRender: false,
          title: '',
          type: '',
          date: '',
          startDate: null,
          endDate: null,
          startTime: '',
          endTime: '',
          branch: '',
          batch: '',
          classroom: '',
          faculty: facultyId,
          course: '',
          module: '',
          topic: [],
          mcq: '',
          descriptive: '0',
        }))
      : setNewFilterData((prevState) => ({
          ...prevState,
          filterDataRender: false,
          title: '',
          type: '',
          date: '',
          startDate: null,
          endDate: null,
          startTime: '',
          endTime: '',
          branch: '',
          batch: '',
          classroom: '',
          faculty: '',
          course: '',
          module: '',
          topic: [],
          mcq: '',
          descriptive: '0',
        }))

    resetForm()

    const data = facultyId
      ? { startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]), facultyId }
      : { startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) }
    dispatch(getTimetable(data))
  }

  const handleAdd = () => {
    setFormData((prevState) => ({
      ...prevState,
      timeTableDrawerHeader: 'Add Timetable',
      filter: false,
      edit: false,
      add: true,
      title: 'lecture',
      dateSelectionSolo: false,
      dateSelectionWeek: false,
      date: '',
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      branch: '',
      batch: '',
      classroom: '',
      faculty: '',
      course: '',
      module: '',
      topic: [],
      mcq: '',
      descriptive: '0',
      lecture: true,
      onlineExam: false,
      offlineExam: false,
    }))

    setOpen(true)
  }

  const handleEdit = (item) => {
    handleRadioChange(item?.type)
    const branchValue = item?.branch?.branchId
    const moduleValue = item?.courseModule?.courseModuleId

    const batch = batches?.filter((batch) => batch.branchId === branchValue)
    const batchOptions = generateDropdownOptions(batch, 'batchNo', 'batchId')

    const classroom = classrooms?.filter((classroom) => classroom.branchId === branchValue)
    const classroomOptions = generateDropdownOptions(classroom, 'className', 'branchClassRoomId')

    batchOption.current = batchOptions
    classroomOption.current = classroomOptions

    const batchValue = item.batchId
    const course = courses?.find((course) => course.batches.some((batch) => batch.batch_id === batchValue))

    courseOption.current = [
      {
        label: course?.courseName,
        value: course?.courseId,
      },
    ]
    const modules = course?.courseDetails?.map((module) => ({
      label: module.moduleName,
      value: module.moduleId,
    }))
    moduleOption.current = modules

    const module = course?.courseDetails
    const topic = module?.find((module) => module.moduleId === moduleValue)
    topicOption.current = generateDropdownOptions(topic?.course_modules_topics, 'topicName', 'topicId')

    setFormData((prevState) => ({
      ...prevState,
      title: item.type,
      date: item.date,
      startDate: item.date,
      endDate: item.date,
      startTime: convertAMPMToObject(item.startTime),
      endTime: convertAMPMToObject(item.endTime),
      branch: item.branch.branchId,
      batch: item.batch.batchId,
      classroom: item.branchClassroomId,
      faculty: item.facultyId,
      course: item.course.courseId,
      module: item.courseModule.courseModuleId,
      topic: item.courseModuleTopicId,
      mcq: item.mcqMark,
      // descriptive: item.descriptiveMark,
      descriptive: '0',
      timeTableDrawerHeader: 'Edit Timetable',
      filter: false,
      add: false,
      edit: true,
      timetableId: item.timetableId,
    }))
    setOpen(true)
  }
  const handleDeleteTimeTable = (item) => {
    const data = {
      saveState,
      setSaveState,
      timetableId: item.timetableId,
      setOpen,
      filter: { ...newFilterData, startDate: convertDateInTZ(weekDates[0]), endDate: convertDateInTZ(weekDates[6]) },
    }
    dispatch(deleteTimetable(data))
  }

  const handleBranchDropdownChange = (e, setFieldValue) => {
    setFieldValue('batch', null)
    setFieldValue('classroom', null)
    const branchValue = e.target.value
    e.preventDefault()
    const batch = batches?.filter((batch) => batch.branchId === branchValue)
    const batchOptions = generateDropdownOptions(batch, 'batchNo', 'batchId')

    const classroom = classrooms?.filter((classroom) => classroom.branchId === branchValue)
    const classroomOptions = generateDropdownOptions(classroom, 'className', 'branchClassRoomId')

    batchOption.current = batchOptions
    classroomOption.current = classroomOptions

    setFieldValue('branch', branchValue)
  }

  const handleBatchDropdownChange = (e, setFieldValue) => {
    e.preventDefault()
    setFieldValue('course', null)
    setFieldValue('module', null)
    const batchValue = e.target.value
    const course = courses?.find((course) => course.batches.some((batch) => batch.batch_id === batchValue))
    courseOption.current = [
      {
        label: course?.courseName,
        value: course?.courseId,
      },
    ]
    setFieldValue('course', course?.courseId)

    const modules = generateDropdownOptions(course?.courseDetails, 'moduleName', 'moduleId')

    moduleOption.current = modules?.length ? modules : []
    setFieldValue('batch', batchValue)
  }

  const handleModuleDropdownChange = (e, setFieldValue, values) => {
    e.preventDefault()
    setFieldValue('topic', null)
    const batchValue = values.batch
    const moduleValue = e.target.value
    const course = courses?.find((course) => course.batches.some((batch) => batch.batch_id === batchValue))
    const module = course?.courseDetails
    const topic = module?.find((module) => module.moduleId === moduleValue)

    topicOption.current = generateDropdownOptions(topic?.course_modules_topics, 'topicName', 'topicId')
    setFieldValue('module', moduleValue)
  }

  const handleTopicDropdownChange = (e, setFieldValue) => {
    setFieldValue('topic', e)
  }

  const initialValues = {
    title: formData.title,
    dateSelectionType: 'dateSelectionSolo',
    dateSelectionSolo: true,
    dateSelectionWeek: false,
    startDate: formData.startDate,
    endDate: formData.endDate,
    startTime: formData.startTime ||  new Date(),
    endTime: formData.endTime ||  new Date(new Date().getTime() + 60 * 60 * 1000),
    branch: formData.branch,
    batch: formData.batch,
    classroom: formData.classroom,
    faculty: formData.faculty,
    course: formData.course,
    module: formData.module,
    topic: formData.topic,
    mcq: formData.mcq,
    type: formData.type,
    // descriptive: formData.descriptive,
    descriptive: '0',
  }
  const initialFilterValues = {
    title: newFilterData.title,
    dateSelectionType: 'dateSelectionSolo',
    dateSelectionSolo: true,
    dateSelectionWeek: false,
    startDate: newFilterData.startDate,
    endDate: newFilterData.endDate,
    startTime: newFilterData.startTime,
    endTime: newFilterData.endTime,
    branch: newFilterData.branch,
    batch: newFilterData.batch,
    classroom: newFilterData.classroom,
    faculty: newFilterData.faculty,
    course: newFilterData.course,
    module: newFilterData.module,
    topic: newFilterData.topic,
    mcq: newFilterData.mcq,
    type: newFilterData.type,
    // descriptive: newFilterData.descriptive,
    descriptive: 0,
  }

  const DrawerList = () => {
    return (
      <>
        <Box className='timetable-drawer' role='presentation'>
          <Box className='timetable-drawer-header flex justify-between align-center'>
            <Typography className='timetable-drawer-title'>{formData.timeTableDrawerHeader}</Typography>
            <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={closeDrawer} />
          </Box>
          <Box className='drawer-horizontal-line' />

          <Formik
            initialValues={formData.filter ? initialFilterValues : initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleFormSubmit(values)
            }}
            // onSubmit={formik.handleSubmit}
          >
            {({ values, handleChange, handleSubmit, setFieldValue, resetForm }) => (
              <Form>
                <div className='timetable-drawer-input-fields'>
                  {!formData.filter && (
                    <div className='flex flex-column'>
                      <div className='timetable-drawer-input-radio flex align-center'>
                        <label className='timetable-drawer-input-radio-label' htmlFor='title'>
                          Title
                        </label>
                        <div
                          role='group'
                          className='timetable-drawer-input-radio-options flex align-center'
                          aria-labelledby='title-radio-group'
                        >
                          <label className='timetable-drawer-input-radio-option-label flex align-center'>
                            <Field
                              type='radio'
                              name='title'
                              value='lecture'
                              className='custom-radio'
                              onChange={(e) => handleRadioChange(e.target.value, resetForm)}
                              checked={formData.lecture}
                            />
                            Lecture
                          </label>
                          <label className='timetable-drawer-input-radio-option-label flex align-center'>
                            <Field
                              type='radio'
                              name='title'
                              value='offline_exam'
                              className='custom-radio'
                              onChange={(e) => handleRadioChange(e.target.value, resetForm)}
                              checked={formData.offlineExam}
                            />
                            Offline Exam
                          </label>
                          <label className='timetable-drawer-input-radio-option-label flex align-center'>
                            <Field
                              type='radio'
                              name='title'
                              value='online_exam'
                              className='custom-radio'
                              onChange={(e) => handleRadioChange(e.target.value, resetForm)}
                              checked={formData.onlineExam}
                            />
                            Online Exam
                          </label>
                        </div>
                      </div>
                      <ErrorMessage name='title' component='div' className='error-msg' />
                    </div>
                  )}
                  {!formData.filter && (
                    <div className='flex flex-column'>
                      <div className='timetable-drawer-input-radio flex align-center mt-0'>
                        <label className='timetable-drawer-input-radio-label' htmlFor='title'>
                          Date
                        </label>
                        {formData.add && (
                          <div
                            role='group'
                            className='timetable-drawer-input-radio-options flex align-center'
                            aria-labelledby='title-radio-group'
                          >
                            <label className='timetable-drawer-input-radio-option-label flex align-center'>
                              <Field
                                type='radio'
                                name='dateSelectionType'
                                value='dateSelectionSolo'
                                className='custom-radio'
                                onChange={(e) => handleDateRadioChange(e.target.value, setFieldValue)}
                                checked={values.dateSelectionType === 'dateSelectionSolo'}
                              />
                              Specific Date
                            </label>
                            <label className='timetable-drawer-input-radio-option-label flex align-center'>
                              <Field
                                type='radio'
                                name='dateSelectionType'
                                value='dateSelectionWeek'
                                className='custom-radio'
                                onChange={(e) => handleDateRadioChange(e.target.value, setFieldValue)}
                                checked={values.dateSelectionType === 'dateSelectionWeek'}
                              />
                              Weekly Date
                            </label>
                          </div>
                        )}
                      </div>
                      <ErrorMessage name='title' component='div' className='error-msg' />
                    </div>
                  )}

                  <div className='timetable-drawer-input-pair-date flex justify-between'>
                    {values.dateSelectionType === 'dateSelectionSolo' ? (
                      <Calendar
                        className={'timetable-drawer-form-calendar'}
                        value={convertTZToDate(values.endDate)}
                        onChange={(values) => {
                          setFieldValue('startDate', convertDateFormatCalendar(values))
                          setFieldValue('endDate', convertDateFormatCalendar(values))
                        }}
                        name='endDate'
                        label={`${formData.filter ? 'Date' : ''}`}
                        labelGap={formData.filter ? '22px' : 0}
                        gap='0'
                        width='100%'
                        required={formData.filter ? false : true}
                        defaultToToday={true}
                      />
                    ) : (
                      <WeeklyDateRange name='endDate' values={values} setFieldValue={setFieldValue} />
                    )}
                  </div>

                  <div className='timetable-drawer-input-pair flex justify-between'>
                    {!formData.filter && (
                      <div className='timetable-drawer-input'>
                        <TimeRange
                          startValue={values.startTime}
                          endValue={values.endTime}
                          onChange={handleChange}
                          hourFormat={'12'}
                          startPlaceholder={'8:00 AM'}
                          endPlaceholder={'9:00 AM'}
                          startName={'startTime'}
                          endName={'endTime'}
                          className={'timetable-from-to-range'}
                          timeRangeClassName={'timetable-drawer-input'}
                          toLabelClassName={'timetable-from-to-label'}
                          titleLabelClassName={'timetable-drawer-input-label'}
                          // setWeekly={(value) => setFormData((prevState) => ({ ...prevState, weekly: value }))}
                          required={formData.filter ? false : true}
                        />
                      </div>
                    )}
                    <div className='timetable-drawer-input'>
                      <label className='timetable-drawer-input-label' htmlFor=''>
                        Branch {formData.filter ? '' : <span className='required-symbol'>*</span>}
                      </label>
                      <PageDropdown
                        options={branchOption}
                        selectedValue={values.branch}
                        className={'timetable-drawer-option'}
                        onChange={(e) => handleBranchDropdownChange(e, setFieldValue)}
                        name={'branch'}
                        placeholder={'Select branch'}
                      />
                      <ErrorMessage name='branch' component='div' className='error-msg' />
                    </div>

                    {formData.filter && (
                      <div className='timetable-drawer-input'>
                        <label className='timetable-drawer-input-label' htmlFor=''>
                          Type
                        </label>
                        <PageDropdown
                          options={typeOption}
                          selectedValue={values.type}
                          className={'timetable-drawer-option'}
                          onChange={handleChange}
                          name={'type'}
                          placeholder={'Select type'}
                        />
                        <ErrorMessage name='type' component='div' className='error-msg' />
                      </div>
                    )}
                  </div>

                  <div className='timetable-drawer-input-pair flex justify-between'>
                    <div className='timetable-drawer-input'>
                      <label className='timetable-drawer-input-label' htmlFor=''>
                        Batch {formData.filter ? '' : <span className='required-symbol'>*</span>}
                      </label>
                      <PageDropdown
                        options={batchOption?.current}
                        selectedValue={values.batch}
                        className={`timetable-drawer-option ${values.branch ? '' : 'timetable-drawer-input-grey'}`}
                        onChange={(e) => handleBatchDropdownChange(e, setFieldValue)}
                        name={'batch'}
                        placeholder={'Select batch'}
                        disabled={!values.branch}
                      />
                      <ErrorMessage name='batch' component='div' className='error-msg' />
                    </div>

                    <div className='timetable-drawer-input'>
                      <label className='timetable-drawer-input-label' htmlFor=''>
                        Classroom {formData?.filter ? '' : <span className='required-symbol'>*</span>}
                      </label>
                      <PageDropdown
                        options={classroomOption.current}
                        selectedValue={values.classroom}
                        className={`timetable-drawer-option ${values.branch ? '' : 'timetable-drawer-input-grey'}`}
                        onChange={handleChange}
                        name={'classroom'}
                        placeholder={'Select classroom'}
                        disabled={!values.branch}
                      />
                      <ErrorMessage name='classroom' component='div' className='error-msg' />
                    </div>
                  </div>

                  <div className='timetable-drawer-input-pair flex justify-between'>
                    <div className='timetable-drawer-input'>
                      <label className='timetable-drawer-input-label' htmlFor=''>
                        Faculty {formData.filter ? '' : <span className='required-symbol'>*</span>}
                      </label>
                      <PageDropdown
                        options={facultyOption}
                        selectedValue={values.faculty}
                        className={`timetable-drawer-option ${facultyId && 'timetable-drawer-input-grey'}`}
                        onChange={handleChange}
                        name={'faculty'}
                        placeholder={'Select faculty'}
                        disabled={facultyId}
                      />
                      <ErrorMessage name='faculty' component='div' className='error-msg' />
                    </div>

                    <div className='timetable-drawer-input'>
                      <label className='timetable-drawer-input-label' htmlFor=''>
                        Course
                      </label>
                      <PageDropdown
                        options={courseOption?.current}
                        selectedValue={values.course}
                        className={'timetable-drawer-option timetable-drawer-input-grey'}
                        onChange={handleChange}
                        name={'course'}
                        placeholder={'Select course'}
                        disabled={true}
                      />
                      <ErrorMessage name='course' component='div' className='error-msg' />
                    </div>
                  </div>

                  {!formData.filter && (
                    <div className='timetable-drawer-input-pair'>
                      <div className='timetable-drawer-input-module timetable-drawer-input'>
                        <label className='timetable-drawer-input-label' htmlFor=''>
                          Module {formData.filter ? '' : <span className='required-symbol'>*</span>}
                        </label>
                        <PageDropdown
                          options={moduleOption?.current}
                          selectedValue={values.module}
                          className={`timetable-drawer-option-module timetable-drawer-option ${values.batch ? '' : 'timetable-drawer-input-grey'}`}
                          onChange={(e) => handleModuleDropdownChange(e, setFieldValue, values)}
                          name={'module'}
                          placeholder={'Select module'}
                          disabled={!values.batch}
                          width={'100%'}
                        />
                        <ErrorMessage name='module' component='div' className='error-msg' />
                      </div>
                    </div>
                  )}
                  {/* <div className='timetable-drawer-input-pair'>
                      <div className='timetable-drawer-input-multi-select'>
                        <label className='timetable-drawer-input-label' htmlFor=''>
                          Module {formData.filter ? '' : <span className='required-symbol'>*</span>}
                        </label>
                        <MultiSelectDropdown
                          className={`timetable-drawer-option ${values.batch ? '' : 'timetable-drawer-input-grey'}`}
                          disabled={!values.batch}
                          name={'module'}
                          placeholder={'Select module'}
                          selectedValue={values.module}
                          options={moduleOption?.current}
                          onChange={(e) => handleModuleDropdownChange(e, setFieldValue, values)}
                        />
                        <ErrorMessage name='module' component='div' className='error-msg' />
                      </div>
                    </div> */}
                  {!formData.filter && (
                    <div className='timetable-drawer-input-pair'>
                      <div className='timetable-drawer-input-multi-select'>
                        <label className='timetable-drawer-input-label' htmlFor=''>
                          Topics {formData.filter ? '' : <span className='required-symbol'>*</span>}
                        </label>
                        <MultiSelectDropdown
                          options={topicOption.current}
                          selectedValue={values?.topic}
                          className={`timetable-drawer-option ${values.module ? '' : 'timetable-drawer-input-grey'}`}
                          onChange={(e) => handleTopicDropdownChange(e, setFieldValue)}
                          name={'topic'}
                          placeholder={'Select topics'}
                          disabled={!values?.module?.length}
                        />
                        <ErrorMessage name='topic' component='div' className='error-msg' />
                      </div>
                    </div>
                  )}

                  {/* <div className='timetable-drawer-input'>
                    <label className='timetable-drawer-input-label' htmlFor=''>
                      Topics {formData.filter ? '' : <span className='required-symbol'>*</span>}
                    </label>
                    <PageDropdown
                      options={topicOption.current}
                      selectedValue={values.topic}
                      className={`timetable-drawer-option ${values.module ? '' : 'timetable-drawer-input-grey'}`}
                      onChange={handleChange}
                      name={'topic'}
                      placeholder={'Select topics'}
                      disabled={!values.module}
                    />
                    <ErrorMessage name='topic' component='div' className='error-msg' />
                  </div> */}
                </div>
                {/* </div> */}
                <div className='timetable-drawer-input-pair flex justify-between'>
                  {formData.onlineExam && (
                    <div className='timetable-drawer-input-marks marks-div-timetable'>
                      <NewInput
                        fieldClassName='timetable-drawer-input-marks-field'
                        label='Marks'
                        name='mcq'
                        placeholder='50 MCQ'
                        width='45%'
                        gap='12px'
                        onInput={handleInput}
                        maxLength={3}
                        required={formData.filter ? false : true}
                      />

                      <div className='nolabel-div'>
                        <NewInput
                          fieldClassName='timetable-drawer-input-marks-field'
                          label='Marks'
                          name='descriptive'
                          placeholder='Descriptive'
                          width='100%'
                          onInput={handleInput}
                          maxLength={3}
                          disabled={true}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div className={`timetable-drawer-save flex justify-end ${formData.filter ? 'justify-between' : ''}`}>
                  {formData.filter && (
                    <Button
                      customClassName={`calendar-form-clear-btn ${formData.filter ? 'calendar-form-save-btn-width' : ''}`}
                      onClick={(e) => handleClear(e, resetForm)}
                    >
                      {UI_CONSTANT.CLEAR_ALL}
                    </Button>
                  )}
                  <Button
                    customClassName={`calendar-form-save-btn ${formData.filter ? 'calendar-form-save-btn-width' : ''}`}
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? UI_CONSTANT.LOADING : UI_CONSTANT.SAVE_NOW}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Box>
      </>
    )
  }

  const TimetableDate = ({ weekSoloDate }) => {
    const dateObject = dayjs(weekSoloDate, 'DD/MM/YYYY')
    const dateString = dateObject.$d
    const dateStr = dateString.toString()
    const dateParts = dateStr.split(' ')
    const day = dateParts[0]
    const month = dateParts[1]
    const date = dateParts[2]

    return (
      <div className='timetable-dates flex justify-center flex-column align-center'>
        <div className='timetable-month'>{month}</div>
        <div className='timetable-date'>{date}</div>
        <div className='timetable-day'>{day.toUpperCase()}</div>
      </div>
    )
  }

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.TIME_TABLE.LABEL_TIMETABLE,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: roleName && roleName == 'faculty' ? ROUTES_PATH.FACULTY_DASHBOARD : ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.TIME_TABLE.LABEL_TIMETABLE,
      link: ROUTES_PATH.TIMETABLE,
    },
  ]

  const handleCondition = roleName == UI_CONSTANT.ADMIN_ROLE || roleName == UI_CONSTANT.BRANCH_ROLE

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className='timetable-list'>
          <div className='subheader flex justify-between'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

            <WeeklyCalendar
              value={weekDateValue}
              setValue={setWeekDateValue}
              buttonFormat={'week'}
              // setArrow={setArrow}
            />

            <div className='timetable-subheader-btn-group flex justify-end align-center sm-btns'>
              {UseAuthorization(permissions.FILTER_TIMETABLE) && (
                <Button
                  onClick={handleFilter}
                  icon={'filter2'}
                  className={'timetable-filter-button flex justify-center align-center'}
                >
                  {UI_CONSTANT.FILTER}
                </Button>
              )}

              {/* {roleName !== 'faculty' && UseAuthorization("ADD_TIMETABLE") && ( */}
              {UseAuthorization(permissions.ADD_TIMETABLE) && (
                <Button onClick={handleAdd} className={'timetable-add-button flex align-center'}>
                  {UI_CONSTANT.TIME_TABLE.ADD_TIME_TABLE}
                </Button>
              )}
            </div>

            <Drawer anchor='right' open={open} onClose={closeDrawer}>
              <DrawerList />
            </Drawer>
          </div>
          <div className='timetable-data'>
            <table className='timetable-data-table'>
              <tbody>
                <>
                  <tr className={`timetable-table-header ${animationClass}`}>
                    {weekDates.map((weekSoloDate, index) => (
                      <th key={index}>
                        <TimetableDate weekSoloDate={weekSoloDate} />
                      </th>
                    ))}
                  </tr>
                  <tr className={`timetable-table-cards`}>
                    {weekDates.map((date, index) => {
                      const dateFilterCheck = timetableData.map((item) => {
                        return item[0]
                      })
                      const isDateAvailable = dateFilterCheck.findIndex((i) => i.date === convertDateInTZ(date))
                      return (
                        <td className='timetable-table-card' key={index} style={{position: 'relative'}}>
                          <TimetableCard
                            onClick={handleCondition ? handleEdit : () => {}}
                            timetableData={isDateAvailable >= 0 ? timetableData[isDateAvailable] : []}
                            onDelete={handleDeleteTimeTable}
                          />
                        </td>
                      )
                    })}
                  </tr>
                </>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}

export default Timetable
